import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function tableCell(theme: Theme): ComponentStyle {
  return {
    componentName: 'tableCell',
    baseStyle: {
      borderTop: `1px solid ${theme.colors.border15}`,
      fontSize: theme.sizes['0'],
      gap: theme.space['2xs']
    }
  };
}
